import {selectSharedGameState} from '../../../redux/reducers/sharedStateReducer/selectors';

/**
 * Действует ли в партии правило «без городов — без монет»: у игрока без
 * единого города нет ни базового, ни бонусного дохода (бонус ботов и бонус
 * лобби, доплата лепреконов), а в конце раунда все его монеты сгорают.
 *
 * Записи матчей проигрываются через редьюсеры, поэтому правило зависит от
 * записи: партии, сыгранные до него, обязаны проигрываться по-старому — иначе
 * монеты и очки (а изредка и исход: досрочный конец по отрыву) разошлись бы
 * с сыгранными. Флаг isCitylessEconomyRule ставит LOAD_STATE (см. loadState в
 * redux/actions); у старых записей его нет — только у них он false.
 *
 * @param {Object} [gameState] - состояние партии
 * @returns {boolean}
 */
export const checkIfCitylessEconomyRule = (gameState) => gameState?.isCitylessEconomyRule !== false;

export const selectIsCitylessEconomyRule = (state) => checkIfCitylessEconomyRule(selectSharedGameState(state));
